import React, { FC, ReactNode, useState } from 'react';
import { ExecutiveContext } from './context';
import { ProcurementType } from 'models/procurement.model';

const ExecutiveProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [procurementToUpdate, setProcurementToUpdate] = useState<ProcurementType | any>(null);
  return (
    <ExecutiveContext.Provider
      value={{
        procurementToUpdate,
        setProcurementToUpdate
      }}>
      {children}
    </ExecutiveContext.Provider>
  );
};

export default ExecutiveProvider;
